import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  ArrowLeftSquareFill,
  CaretDownFill,
  XCircleFill,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import encrypt from "../../utils/helpers/encrypt";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import CustomButton from "../../components/CustomButton/CustomButton";

const AddSurveyQuiz: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [options, setOptions] = useState<string[]>([""]);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [showWarning, setShowWarning] = useState(false);
  const [questionImagePreview, setQuestionImagePreview] = useState<
    string | null
  >(null);
  const [filePreviews, setFilePreviews] = useState<(string | null)[]>([null]);
  const [selectedFieldType, setSelectedFieldType] =
    useState<string>("Textual Option");
  const [showCropper, setShowCropper] = useState<boolean>(false);
  const [currentImage, setCurrentImage] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<number | null>(
    null
  );
  const [folderId, setFolderId] = useState<string>("");
  const [question, setQuestion] = useState("");
  const [questionFile, setQuestionFile] = useState<File | null>(null);
  const [optionFiles, setOptionFiles] = useState<File[]>([]);
  const [points, setPoints] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const [folderError, setFolderError] = useState("");
  const [folders, setFolders] = useState<{ id: string; folder_name: string }[]>(
    []
  );
  const maxLength = 500;

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchQuizData();
  }, []);


  const fetchQuizData = async () => {
    try {
      dispatch(showLoader('Loading data...'));
      const response = await postDetails(APIList.GET_SURVEY_DATA_BY_TYPE, {sort: "Quiz"});
      console.log(response.data)
      setData(response.data)

      const folderData = response.data.map((item: any) => ({
        id: item.id,
        folder_name: item.name,
      }));
      setFolders(folderData);

      if (folderData.length > 0) {
        handleQuizTypeChange(response.data[0].quiz_type);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally{
      dispatch(hideLoader());
  }
  };

  const handleQuizTypeChange = (type: number) => {
    let fieldType: string;
    switch (type) {
      case 1:
        fieldType = "Textual Option";
        break;
      case 2:
        fieldType = "Descriptive Option";
        break;
      case 3:
        fieldType = "Image Option";
        break;
      case 4:
        fieldType = "Image Ordering Option";
        break;
      default:
        fieldType = "Textual Option";
        break;
    }
    setSelectedFieldType(fieldType);
  };

  const handleAddOption = () => {
    setOptions([...options, ""]);
    setFilePreviews([...filePreviews, null]);
  };

  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleOptionSelect = (index: number) => {
    setSelectedOption(index);
    setShowWarning(true);
  };

  const handleQuestionImageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setQuestionFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentImage(reader.result as string);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setOptionFiles((prev) => {
        const newFiles = [...prev];
        newFiles[index] = file;
        return newFiles;
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentImage(reader.result as string);
        setCurrentImageIndex(index);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);

      const newOptions = [...options];
      newOptions[index] = file.name;
      setOptions(newOptions);
    }
  };

  const checkForDuplicates = (options: string[]): boolean => {
    return new Set(options).size !== options.length;
  };

  const handleImageRemove = (index: number) => {
    const newPreviews = [...filePreviews];
    newPreviews[index] = null;
    setFilePreviews(newPreviews);
  };

  const handleRemoveOption = (index: number) => {
    setOptions(options.filter((_, i) => i !== index));
    setFilePreviews(filePreviews.filter((_, i) => i !== index));
  };

  const handleQuestionChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setQuestion(e.target.value);

  const handleSelectedField = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setSelectedFieldType(e.target.value);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!folderId) {
      // dispatch(showToast("Please Select a Survey"));
      // setTimeout(() => dispatch(hideToast()), 3000);
      setFolderError("Select a Survey")
      return;
    }

    setFolderError("")

    if (
      (selectedFieldType !== "Descriptive Option" && options.length < 2) ||
      options.length === 0 ||
      (selectedFieldType !== "Image Ordering Option" &&
        selectedOption === null) ||
      (selectedFieldType !== "Descriptive Option" &&
        checkForDuplicates(options))
    ) {

      let errorMessage = "";

      if (selectedFieldType !== "Descriptive Option" && options.length < 2) {
        errorMessage += "Please add at least two options.\n";
      }

      if (options.length === 0) {
        errorMessage += "Please add at least one option.\n";
      }

      if (
        selectedFieldType !== "Image Ordering Option" &&
        selectedFieldType !== "Descriptive Option" &&
        selectedOption === null
      ) {
        errorMessage += "Please select the correct answer.\n";
      }

      if (
        selectedFieldType !== "Descriptive Option" &&
        checkForDuplicates(options)
      ) {
        errorMessage += "Please ensure there are no duplicate options.\n";
      }

    if (errorMessage) {
      dispatch(showToast(errorMessage.trim()));
      setTimeout(() => dispatch(hideToast()), 7000);
      return;
    }
  }

    const formData = new FormData();

    const formattedOptions = options.map((option, index) => {
      if (selectedFieldType === "Image Ordering Option") {
        return {
          text: optionFiles[index]?.name || "",
          value: (index + 1).toString(),
        };
      } else {
        return {
          text: option,
          value: selectedOption === index ? "true" : "false",
        };
      }
    });

    if (questionFile) {
      formData.append("question_file", questionFile);
    }

    options.forEach((_, index) => {
      if (optionFiles[index]) {
        formData.append(`option_file`, optionFiles[index]);
      }
    });

    const quizTypeMap: { [key: string]: number } = {
      "Textual Option": 1,
      "Descriptive Option": 2,
    };

    const quizType = quizTypeMap[selectedFieldType] || 1;

    const payload = {
      survey_id: Number(folderId),
      quiz_type: quizType,
      question,
      options: formattedOptions,
    };

    formData.append("data", encrypt(payload));
    // console.log(payload)

    try {
      const response = await postMultipartDetails(APIList.ADD_SURVEY_QUIZ, formData);
      console.log("Response:", response);
      if (response.statusCode === 200) {
        navigate("/survey")
        dispatch(showToast("Quiz Added Successfully."))
      } else {
        dispatch(showToast("Failed to add quiz"));
      }
    } catch (error) {
      console.error("Error submitting quiz:", error);
      dispatch(showToast("Some error occurred while submitting quiz"))
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const buttons = [
    {
      label: "Back to Main List",
      theme: "danger",
      icon: <ArrowLeftSquareFill />,
      onClick: ()=>{navigate("/survey")},
    },
  ];

  return (
    <LayoutContainer title="Add Training Quiz">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-plus"></i>
          Add Survey Quiz
        </h2>
      <PageHeader buttons={buttons} />
      </div>
      <div className="form-control-margin mb-4">
        <Form onSubmit={handleSubmit}>
          <Row >
            <Col xs={6}>
              <Form.Group controlId="formFolder" className="mb-3" 
              style={{
              height:"100px"
            }}>
                <Form.Label>Select Survey <span className="text-danger" >*</ span></Form.Label>
                <InputGroup>
                  <Form.Control
                    as="select"
                    className="form-select required-field"
                    value={folderId}
                    onChange={(e) => {
                      console.log(e);
                      setFolderId(e.target.value);
                    }}
                  >
                    <option value="" disabled hidden>Please select survey</option>
                    {folders.map((folder) => (
                      <option key={folder.id} value={folder.id}>
                        {folder.folder_name}
                      </option>
                    ))}
                  </Form.Control>
                </InputGroup>
              {folderError && (
                  <p className="error-text font-12 mt-1">{folderError}</p> 
                )}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formFieldType" className="mb-3">
                <Form.Label>Select Quiz Type <span className="text-danger">*</span></Form.Label>
                <InputGroup>
                  <Form.Control
                    as="select"
                    className="form-select required-field"
                    value={selectedFieldType}
                    onChange={handleSelectedField}
                  >
                    <option>Textual Option</option>
                    <option>Descriptive Option</option>
                  </Form.Control>
                  
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
   
          <Row>
          <Col xs={12}>
          <Form.Group controlId="formQuestion" className="mb-3">
            <Form.Label>Enter Question <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter question"
              className="form-question"
              onChange={handleQuestionChange}
              required={true}
              maxLength={maxLength}
            />
             <div style={{ marginTop: '8px', fontSize: '14px', color: '#555', textAlign:"end" }}>
             {question.length}/{maxLength}
            </div>
          </Form.Group>
          </Col>
          </Row>

          {selectedFieldType === "Textual Option" &&
            options.map((option, index) => (
              <Form.Group
                key={index}
                controlId={`formTextOption-${index}`}
                className="mb-3"
              >
                <Row className="align-items-center">
                  <Col xs={1}>
                    <Form.Check
                      type="radio"
                      name="correctAnswer"
                      checked={selectedOption === index}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleOptionSelect(index)
                        e.currentTarget.blur();
                      }}
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Control
                      type="text"
                      value={option}
                      maxLength={100}
                      placeholder="Quiz Option"
                      required={true}
                      onChange={(e) =>
                        handleOptionChange(index, e.target.value)
                      }
                      className="required-field"
                    />
                  </Col>
                  <Col xs={2}>
                    {index > 0 ? (
                      <Button
                        variant="secondary"
                        onClick={() => handleRemoveOption(index)}
                        style={{
                          boxShadow: "none"
                        }}
                      >
                        × Remove
                      </Button>
                    ) : (
                      <Button
                        onClick={handleAddOption}
                        // className="btn-add"
                         variant="danger"
                        style={{
                          boxShadow: "none"
                        }}
                        disabled={options.some(
                          (option, index) =>
                            option === ""
                        )}
                      >
                        + Add More
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form.Group>
            ))}

          {selectedFieldType === "Descriptive Option"}

          <div className="d-flex justify-content-center mt-5" style={{width:"40%", margin:"auto"}}>
            {/* <Button type="submit" className="btn-submit text-white">
              Submit
            </Button> */}
            <CustomButton type="submit" size="md" theme="yellow">
            Submit
            </CustomButton>
          </div>
        </Form>
      </div>
    </LayoutContainer>
  );
};

export default AddSurveyQuiz;
